// COMPLETELY REWRITTEN SOLUTION TO FIX SUNDAY DELIVERY ISSUE

document.addEventListener('DOMContentLoaded', function() {
    setupDeliveryCalculation();
});

function setupDeliveryCalculation() {
    // Setup the countdown timer component - this can stay the same
    if (!customElements.get('countdown-timer')) {
        class CountdownTimer extends HTMLElement {
            constructor() {
                super();
                this.attachShadow({ mode: 'open' });
                this.render();
            }

            connectedCallback() {
                this.startTimer();
            }

            disconnectedCallback() {
                this.stopTimer();
            }

            startTimer() {
                this.updateCountdown();
                this.interval = setInterval(() => this.updateCountdown(), 1000);
            }

            stopTimer() {
                if (this.interval) {
                    clearInterval(this.interval);
                    this.interval = null;
                }
            }

            updateCountdown() {
                const now = new Date();
                const currentHour = now.getHours();

                // Set target time based on current hour
                const targetTime = new Date(now);

                if (currentHour < 12) {
                    // Before noon: set target to noon today
                    targetTime.setHours(12, 0, 0, 0);
                } else {
                    // After noon: set target to midnight
                    targetTime.setHours(23, 59, 59, 999);
                }

                // Calculate time difference
                const timeDifference = targetTime - now;

                // Calculate time components
                const seconds = Math.floor((timeDifference / 1000) % 60);
                const minutes = Math.floor((timeDifference / (1000 * 60)) % 60);
                const hours = Math.floor((timeDifference / (1000 * 60 * 60)));

                // Create a user-friendly display format
                let displayText = '';

                if (hours > 0) {
                    displayText += `${hours}h `;
                }

                if (minutes > 0 || hours > 0) {
                    displayText += `${minutes}m `;
                }

                displayText += `${seconds}s`;

                // Update the display
                this.shadowRoot.querySelector('.countdown').textContent = displayText;
            }

            render() {
                this.shadowRoot.innerHTML = `
                    <style>
                        .countdown {
                            font-weight: bold;
                        }
                    </style>
                    <div class="countdown">Initializing...</div>
                `;
            }
        }

        // Register the custom element
        customElements.define('countdown-timer', CountdownTimer);
    }

    // Set up the initial delivery date without variant selection
    calculateAndSetDeliveryDate();

    // Now set up the label listeners for variant selection
    setupVariantLabelListeners();
}

function calculateAndSetDeliveryDate() {
    console.log('==== CALCULATING DELIVERY DATE ====');

    // Get the delivery date element
    const deliveryDateElement = document.getElementById('delivery-date');
    if (!deliveryDateElement) {
        console.log('Delivery date element not found!');
        return;
    }

    // Get base days from metafield
    let baseDays = 2;
    const metafieldElement = document.getElementById('product-metafield-days');
    if (metafieldElement) {
        baseDays = parseInt(metafieldElement.value) || 2;
        console.log('Base delivery days from metafield:', baseDays);
    }

    // Calculate the base delivery date based on current day and time
    let baseDate = getBaseDeliveryDate();
    console.log('Base delivery date (before variant):', baseDate, baseDate.toDateString());

    // Check for selected variant with data-delivery
    let additionalDays = 0;
    const selectedVariant = document.querySelector('variant-selects input[type="radio"]:checked');

    if (selectedVariant && selectedVariant.hasAttribute('data-delivery')) {
        additionalDays = parseInt(selectedVariant.getAttribute('data-delivery')) || 0;
        console.log('Selected variant has data-delivery:', additionalDays, 'Value:', selectedVariant.value);

        if (additionalDays > 0) {
            // Clone the base date to avoid modifying it
            let variantDate = new Date(baseDate.getTime());
            variantDate.setDate(variantDate.getDate() + additionalDays);
            console.log('Calculated date after adding variant days:', variantDate, variantDate.toDateString());

            // CRITICAL FIX - Check explicitly for Sunday (0) or Monday (1)
            const dayOfWeek = variantDate.getDay();
            console.log('Day of week after adding variant days:', dayOfWeek, '(0=Sun, 1=Mon, etc)');

            if (dayOfWeek === 0) { // Sunday
                console.log('FOUND SUNDAY! Moving to Tuesday');
                variantDate.setDate(variantDate.getDate() + 2); // Add 2 days to get to Tuesday
            } else if (dayOfWeek === 1) { // Monday
                console.log('FOUND MONDAY! Moving to Tuesday');
                variantDate.setDate(variantDate.getDate() + 1); // Add 1 day to get to Tuesday
            }

            // Use the variant date with Sunday/Monday fixed
            baseDate = variantDate;
        }
    }

    // Format and display the final delivery date
    const options = { weekday: 'long', day: '2-digit', month: 'short' };
    const formattedDate = baseDate.toLocaleDateString('en-US', options);

    console.log('FINAL DELIVERY DATE:', formattedDate, 'Day of week:', baseDate.getDay());
    deliveryDateElement.textContent = formattedDate;
    
    // Update the sticky ATC bar with the delivery date
    updateStickyATCDeliveryDate();
    
    console.log('==== END CALCULATION ====');
}

function getBaseDeliveryDate() {
    const now = new Date();
    const currentHour = now.getHours();
    const currentDay = now.getDay(); // 0 = Sunday, 1 = Monday, etc.

    // Create a new date object for the delivery date
    const deliveryDate = new Date(now);

    // Determine if it's before or after noon
    const isBeforeNoon = currentHour < 12;
    console.log('Current day:', currentDay, 'Current hour:', currentHour, 'Before noon:', isBeforeNoon);

    // Apply delivery rules based on day of week and time of day
    switch (currentDay) {
        case 0: // Sunday
            // Always Tuesday delivery (add 2 days)
            deliveryDate.setDate(now.getDate() + 2);
            console.log('Sunday → Tuesday (base)');
            break;

        case 1: // Monday
            if (isBeforeNoon) {
                // Before noon: Tuesday (add 1 day)
                deliveryDate.setDate(now.getDate() + 1);
                console.log('Monday AM → Tuesday (base)');
            } else {
                // After noon: Wednesday (add 2 days)
                deliveryDate.setDate(now.getDate() + 2);
                console.log('Monday PM → Wednesday (base)');
            }
            break;

        case 2: // Tuesday
            if (isBeforeNoon) {
                // Before noon: Wednesday (add 1 day)
                deliveryDate.setDate(now.getDate() + 1);
                console.log('Tuesday AM → Wednesday (base)');
            } else {
                // After noon: Thursday (add 2 days)
                deliveryDate.setDate(now.getDate() + 2);
                console.log('Tuesday PM → Thursday (base)');
            }
            break;

        case 3: // Wednesday
            if (isBeforeNoon) {
                // Before noon: Thursday (add 1 day)
                deliveryDate.setDate(now.getDate() + 1);
                console.log('Wednesday AM → Thursday (base)');
            } else {
                // After noon: Friday (add 2 days)
                deliveryDate.setDate(now.getDate() + 2);
                console.log('Wednesday PM → Friday (base)');
            }
            break;

        case 4: // Thursday
            if (isBeforeNoon) {
                // Before noon: Friday (add 1 day)
                deliveryDate.setDate(now.getDate() + 1);
                console.log('Thursday AM → Friday (base)');
            } else {
                // After noon: Saturday (add 2 days)
                deliveryDate.setDate(now.getDate() + 2);
                console.log('Thursday PM → Saturday (base)');
            }
            break;

        case 5: // Friday
            if (isBeforeNoon) {
                // Before noon: Saturday (add 1 day)
                deliveryDate.setDate(now.getDate() + 1);
                console.log('Friday AM → Saturday (base)');
            } else {
                // After noon: Tuesday (add 4 days)
                deliveryDate.setDate(now.getDate() + 4);
                console.log('Friday PM → Tuesday (base)');
            }
            break;

        case 6: // Saturday
            // Always Tuesday (add 3 days)
            deliveryDate.setDate(now.getDate() + 3);
            console.log('Saturday → Tuesday (base)');
            break;
    }

    return deliveryDate;
}

function updateStickyATCDeliveryDate() {
    const deliveryDateElement = document.getElementById('delivery-date');
    const stickyBarElement = document.querySelector('.shopibro-estimated-arrival');
    
    if (deliveryDateElement && stickyBarElement && deliveryDateElement.textContent) {
        // Get the delivery date text and format it
        const deliveryDate = deliveryDateElement.textContent.trim();
        const formattedText = `Estimated arrival date: ${deliveryDate}`;
        
        // Update the sticky bar
        stickyBarElement.textContent = formattedText;
        console.log('Updated sticky ATC bar with delivery date:', formattedText);
    }
}

function setupVariantLabelListeners() {
    console.log('Setting up variant label listeners');

    // Function to attach click listeners to all variant labels
    function attachLabelListeners() {
        const labels = document.querySelectorAll('.base_option_value_label');
        console.log('Found', labels.length, 'variant labels');

        labels.forEach(label => {
            // Remove existing listeners to avoid duplicates
            label.removeEventListener('click', handleLabelClick);

            // Add new click listener
            label.addEventListener('click', handleLabelClick);
            // console.log('Added listener to label:', label.textContent);
        });
    }

    // Handler for label clicks
    function handleLabelClick(e) {
        console.log('Label clicked:', e.target.textContent);

        // Give the browser time to update the checked state
        setTimeout(() => {
            calculateAndSetDeliveryDate();
        }, 100);
    }

    // Attach listeners immediately
    attachLabelListeners();

    // Also watch for dynamically added labels
    const observer = new MutationObserver(mutations => {
        let shouldReattach = false;

        mutations.forEach(mutation => {
            if (mutation.type === 'childList' &&
                mutation.addedNodes.length > 0) {
                // Check if any new labels were added
                for (let i = 0; i < mutation.addedNodes.length; i++) {
                    const node = mutation.addedNodes[i];
                    if (node.classList &&
                        (node.classList.contains('base_option_value_label') ||
                            node.querySelector && node.querySelector('.base_option_value_label'))) {
                        shouldReattach = true;
                        break;
                    }
                }
            }
        });

        if (shouldReattach) {
            console.log('DOM changed, reattaching label listeners');
            attachLabelListeners();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
}

class CountdownTimer2 extends HTMLElement {
    constructor() {
    super();

    // Create shadow DOM
    this.attachShadow({ mode: 'open' });

    // Initial state
    this.hours = 0;
    this.minutes = 0;
    this.seconds = 0;
    this.timerInterval = null;
    this.endTime = null;
    this.storageKey = 'countdown-timer-end-time';
}

    connectedCallback() {
    // Get the data-time attribute (in hours)
    const dataTime = this.getAttribute('data-time');
    const hoursToRun = dataTime ? parseFloat(dataTime) : 1; // Default to 1 hour

    // Check if there's a saved end time in localStorage
    const savedEndTime = localStorage.getItem(this.storageKey);

    if (savedEndTime && !isNaN(savedEndTime) && new Date(parseInt(savedEndTime)) > new Date()) {
    // Resume from saved state
    this.endTime = new Date(parseInt(savedEndTime));
} else {
    // Start fresh with the specified hours
    this.endTime = new Date(new Date().getTime() + hoursToRun * 60 * 60 * 1000);
    localStorage.setItem(this.storageKey, this.endTime.getTime().toString());
}

    // Create the structure of the timer
    this.render();

    // Start the countdown
    this.startCountdown();
}

    disconnectedCallback() {
    // Clean up when element is removed
    if (this.timerInterval) {
    clearInterval(this.timerInterval);
}
}

    startCountdown() {
    this.updateDisplay();

    this.timerInterval = setInterval(() => {
    const currentTime = new Date().getTime();
    const timeLeft = this.endTime - currentTime;

    if (timeLeft <= 0) {
    // Time is up, restart with the original duration
    const dataTime = this.getAttribute('data-time');
    const hoursToRun = dataTime ? parseFloat(dataTime) : 1; // Default to 1 hour

    this.endTime = new Date(new Date().getTime() + hoursToRun * 60 * 60 * 1000);
    localStorage.setItem(this.storageKey, this.endTime.getTime().toString());
}

    this.updateDisplay();
}, 1000);
}

    updateDisplay() {
    const currentTime = new Date().getTime();
    const timeLeft = Math.max(0, this.endTime - currentTime);

    // Calculate hours, minutes, seconds
    this.hours = Math.floor(timeLeft / (1000 * 60 * 60));
    this.minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    this.seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

    // Update the digits in the display
    const digitsContainer = this.shadowRoot.querySelector('.countdown-container');
    if (digitsContainer) {
    // Format hours, minutes and seconds to have two digits
    const hoursTens = Math.floor(this.hours / 10);
    const hoursOnes = this.hours % 10;
    const minutesTens = Math.floor(this.minutes / 10);
    const minutesOnes = this.minutes % 10;
    const secondsTens = Math.floor(this.seconds / 10);
    const secondsOnes = this.seconds % 10;

    // Update all digits
    this.shadowRoot.getElementById('hours-tens').textContent = hoursTens;
    this.shadowRoot.getElementById('hours-ones').textContent = hoursOnes;
    this.shadowRoot.getElementById('minutes-tens').textContent = minutesTens;
    this.shadowRoot.getElementById('minutes-ones').textContent = minutesOnes;
    this.shadowRoot.getElementById('seconds-tens').textContent = secondsTens;
    this.shadowRoot.getElementById('seconds-ones').textContent = secondsOnes;
}
}

    render() {
    // CSS Styles
    const style = document.createElement('style');
    style.textContent = `
                    .countdown-container {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-family: Arial, sans-serif;
                        gap: 3px;
                    }
                    
                    .countdown-digit {
                            background-color: #F27822;
                            color: white;
                            font-size: 13px;
                            font-weight: bold;
                            width: 19px;
                            height: 23px;
                            border-radius: 3px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                    }
                    
                    .countdown-separator {
                        display: flex;
                        flex-direction: column;
                        gap: 5px;
                        font-size: 2px;
                        font-weight: bold;
                        color: #F27822;
                    }
                    .countdown-separator::before,
                    .countdown-separator::after {
                        content: "";
                        display: inline-block;
                        width: 3px;
                        height: 3px;
                        background-color: #F27822;
                        border-radius: 50%; /* Makes it a circle */
                        margin: 0 2px;
                    }
                    
                    @media only screen and (max-width: 768px) {
                       .countdown-container {
                          gap: 2px;
                       }
                    }
                `;

    // Create HTML structure
    const container = document.createElement('div');
    container.className = 'countdown-container';

    container.innerHTML = `
                    <div id="hours-tens" class="countdown-digit">0</div>
                    <div id="hours-ones" class="countdown-digit">0</div>
                    <div class="countdown-separator"></div>
                    <div id="minutes-tens" class="countdown-digit">0</div>
                    <div id="minutes-ones" class="countdown-digit">0</div>
                    <div class="countdown-separator"></div>
                    <div id="seconds-tens" class="countdown-digit">0</div>
                    <div id="seconds-ones" class="countdown-digit">0</div>
                `;

    // Add to shadow DOM
    this.shadowRoot.appendChild(style);
    this.shadowRoot.appendChild(container);
}

    // Add a method to reset the timer
    resetTimer() {
    if (this.timerInterval) {
    clearInterval(this.timerInterval);
}

    localStorage.removeItem(this.storageKey);

    const dataTime = this.getAttribute('data-time');
    const hoursToRun = dataTime ? parseFloat(dataTime) : 1; // Default to 1 hour

    this.endTime = new Date(new Date().getTime() + hoursToRun * 60 * 60 * 1000);
    localStorage.setItem(this.storageKey, this.endTime.getTime().toString());

    this.startCountdown();
}
}

    // Register the custom element
    customElements.define('countdown-timer-2', CountdownTimer2);


class DetailComparisonPopup extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
        this._isMetric = true; // Default to metric
        this._conversionRates = {
            m: 3.28084, // 1m = 3.28084ft
        };
        this._isVisible = false; // Track visibility state
    }

    connectedCallback() {
        this.render();
        this.setupEventListeners();
        // Instead of setting style directly in constructor,
        // use proper visibility management after connection
        this.updateVisibility();
    }

    // Method to update visibility based on _isVisible
    updateVisibility() {
        const popupContainer = this.shadowRoot.querySelector('.backdrop');
        const popupContent = this.shadowRoot.querySelector('.popup-container');

        if (this._isVisible) {
            popupContainer.style.display = 'block';
            popupContent.style.display = 'block';
            document.body.style.overflow = 'hidden'; // Prevent scrolling of the body
        } else {
            popupContainer.style.display = 'none';
            popupContent.style.display = 'none';
            document.body.style.overflow = ''; // Restore body scrolling
        }
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== newValue) {
            this.updateValues();
            if (name === 'data-icons') {
                this.updateIcons();
            }
        }
    }

    static get observedAttributes() {
        return [
            'data-size', 'data-panel-thickness', 'data-easy-setup',
            'data-uv-protected', 'data-all-weather', 'data-door-width', 'data-limited-space',
            'data-garden', 'data-hosting', 'data-art-built', 'data-gym',
            'data-icons'
        ];
    }

    setupEventListeners() {
        const meterBtn = this.shadowRoot.querySelector('.toggle-button[data-unit="meter"]');
        const feetBtn = this.shadowRoot.querySelector('.toggle-button[data-unit="feet"]');

        meterBtn.addEventListener('click', () => this.switchUnit(true));
        feetBtn.addEventListener('click', () => this.switchUnit(false));

        // Close button
        const closeBtn = this.shadowRoot.querySelector('.close-button');
        if (closeBtn) {
            closeBtn.addEventListener('click', () => this.close());
        }
        // Backdrop click to close
        const backdrop = this.shadowRoot.querySelector('.backdrop');
        if (backdrop) {
            backdrop.addEventListener('click', () => this.close());
        }
    }

    // Method to open the popup
    open() {
        this._isVisible = true;
        this.updateVisibility();
    }

    // Method to close the popup
    close() {
        this._isVisible = false;
        this.updateVisibility();
        this.dispatchEvent(new CustomEvent('close'));
    }

    switchUnit(isMetric) {
        this._isMetric = isMetric;

        // Update active toggle button
        const meterBtn = this.shadowRoot.querySelector('.toggle-button[data-unit="meter"]');
        const feetBtn = this.shadowRoot.querySelector('.toggle-button[data-unit="feet"]');

        if (isMetric) {
            meterBtn.classList.add('toggle-active');
            feetBtn.classList.remove('toggle-active');
        } else {
            meterBtn.classList.remove('toggle-active');
            feetBtn.classList.add('toggle-active');
        }

        // Update all unit-dependent values
        this.updateValues();
    }

    updateValues() {
        const categories = ['size', 'panel-thickness', 'door-width'];
        const products = ['standard', 'mini', 'large'];

        // First, reset all cells with classes to have a dash
        this.shadowRoot.querySelectorAll('td[class]').forEach(cell => {
            // Only add dash to cells that don't contain checkmarks or other content
            if (!cell.innerHTML.trim() || cell.textContent === '-') {
                cell.textContent = '-';
            }
        });

        categories.forEach(category => {
            // Get the data attribute name for this category
            const dataAttr = `data-${category}`;
            if (!this.hasAttribute(dataAttr)) return;

            try {
                const categoryData = JSON.parse(this.getAttribute(dataAttr));

                products.forEach(product => {
                    if (!categoryData[product]) return;

                    Object.keys(categoryData[product]).forEach(key => {
                        // Check if we have both metric and imperial values
                        const metricKey = key;
                        const imperialKey = `${key}_feet`;

                        // Find the cell
                        const cell = this.shadowRoot.querySelector(`.${category}-${key}-${product}`);
                        if (!cell) return;

                        if (this._isMetric) {
                            // Use metric value
                            cell.textContent = categoryData[product][metricKey];
                            if (categoryData[product]['highlight']) {
                                cell.classList.add('orange-text');
                            }
                        } else {
                            // Use imperial value if explicitly provided
                            if (categoryData[product][imperialKey]) {
                                cell.textContent = categoryData[product][imperialKey];
                            }
                            // Otherwise convert from metric if possible
                            else if (categoryData[product][metricKey] && this.canConvert(metricKey, categoryData[product][metricKey])) {
                                cell.textContent = this.convertToImperial(metricKey, categoryData[product][metricKey]);
                            }
                            if (categoryData[product]['highlight']) {
                                cell.classList.add('orange-text');
                            }
                        }
                    });
                });
            } catch (error) {
                console.error(`Error parsing ${dataAttr}:`, error);
            }
        });

        // Update features (checkmarks or text)
        const features = ['easy-setup', 'uv-protected', 'all-weather', 'limited-space', 'garden', 'hosting', 'art-built', 'gym'];

        features.forEach(feature => {
            const dataAttr = `data-${feature}`;
            if (!this.hasAttribute(dataAttr)) return;

            try {
                const featureData = JSON.parse(this.getAttribute(dataAttr));

                products.forEach(product => {
                    if (featureData[product] === undefined) return;

                    const cell = this.shadowRoot.querySelector(`.${feature}-${product}`);
                    if (!cell) return;

                    // Check if the value is a boolean or a string
                    if (typeof featureData[product] === 'boolean') {
                        // Handle boolean values as before
                        if (featureData[product]) {
                            cell.innerHTML = '<div class="check-mark"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                                '<path d="M6.95 11.45L12.2375 6.1625L11.1875 5.1125L6.95 9.35L4.8125 7.2125L3.7625 8.2625L6.95 11.45ZM8 15.5C6.9625 15.5 5.9875 15.3031 5.075 14.9094C4.1625 14.5156 3.36875 13.9813 2.69375 13.3063C2.01875 12.6313 1.48438 11.8375 1.09063 10.925C0.696875 10.0125 0.5 9.0375 0.5 8C0.5 6.9625 0.696875 5.9875 1.09063 5.075C1.48438 4.1625 2.01875 3.36875 2.69375 2.69375C3.36875 2.01875 4.1625 1.48438 5.075 1.09063C5.9875 0.696875 6.9625 0.5 8 0.5C9.0375 0.5 10.0125 0.696875 10.925 1.09063C11.8375 1.48438 12.6313 2.01875 13.3063 2.69375C13.9813 3.36875 14.5156 4.1625 14.9094 5.075C15.3031 5.9875 15.5 6.9625 15.5 8C15.5 9.0375 15.3031 10.0125 14.9094 10.925C14.5156 11.8375 13.9813 12.6313 13.3063 13.3063C12.6313 13.9813 11.8375 14.5156 10.925 14.9094C10.0125 15.3031 9.0375 15.5 8 15.5Z" fill="#1C1B1F"/>\n' +
                                '</svg></div>';
                        } else {
                            cell.innerHTML = '-';  // Change from empty string to dash
                        }
                    } else if (typeof featureData[product] === 'string') {
                        // Handle string values
                        if (featureData[product].toLowerCase().includes('checkmark')) {
                            // If string contains 'checkmark', show the checkmark
                            cell.innerHTML = '<div class="check-mark"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                                '<path d="M6.95 11.45L12.2375 6.1625L11.1875 5.1125L6.95 9.35L4.8125 7.2125L3.7625 8.2625L6.95 11.45ZM8 15.5C6.9625 15.5 5.9875 15.3031 5.075 14.9094C4.1625 14.5156 3.36875 13.9813 2.69375 13.3063C2.01875 12.6313 1.48438 11.8375 1.09063 10.925C0.696875 10.0125 0.5 9.0375 0.5 8C0.5 6.9625 0.696875 5.9875 1.09063 5.075C1.48438 4.1625 2.01875 3.36875 2.69375 2.69375C3.36875 2.01875 4.1625 1.48438 5.075 1.09063C5.9875 0.696875 6.9625 0.5 8 0.5C9.0375 0.5 10.0125 0.696875 10.925 1.09063C11.8375 1.48438 12.6313 2.01875 13.3063 2.69375C13.9813 3.36875 14.5156 4.1625 14.9094 5.075C15.3031 5.9875 15.5 6.9625 15.5 8C15.5 9.0375 15.3031 10.0125 14.9094 10.925C14.5156 11.8375 13.9813 12.6313 13.3063 13.3063C12.6313 13.9813 11.8375 14.5156 10.925 14.9094C10.0125 15.3031 9.0375 15.5 8 15.5Z" fill="#1C1B1F"/>\n' +
                                '</svg></div>';
                        } else if (featureData[product] === '') {
                            // Empty string means dash
                            cell.textContent = '-';
                        } else {
                            // Display the text content
                            cell.textContent = featureData[product];
                        }
                    } else {
                        // Handle other cases (null, undefined, etc.)
                        cell.textContent = '-';  // Change from empty string to dash
                    }
                });
            } catch (error) {
                console.error(`Error parsing ${dataAttr}:`, error);
            }
        });
    }

    canConvert(key, value) {
        // Check if we can convert this key and value
        if (!value || typeof value !== 'string') return false;

        // Check if the value contains a unit we can convert
        return Object.keys(this._conversionRates).some(unit => value.endsWith(unit));
    }

    convertToImperial(key, value) {
        // Simple conversion for values with units
        for (const unit in this._conversionRates) {
            if (value.endsWith(unit)) {
                const numericValue = parseFloat(value.replace(unit, ''));
                const convertedValue = (numericValue * this._conversionRates[unit]).toFixed(1);
                return `${convertedValue}ft`;
            }
        }
        return value; // Return original if can't convert
    }

    updateIcons() {
        if (!this.hasAttribute('data-icons')) return;

        try {
            const iconData = JSON.parse(this.getAttribute('data-icons'));
            const products = ['standard', 'mini', 'large'];

            products.forEach(product => {
                if (!iconData[product]) return;

                const iconContainer = this.shadowRoot.querySelector(`.${product}-icon-container`);
                const iconImg = this.shadowRoot.querySelector(`.${product}-icon`);
                const iconTitle = this.shadowRoot.querySelector(`.${product}-title`);

                if (iconImg && iconData[product].src) {
                    iconImg.src = iconData[product].src;
                    iconImg.alt = iconData[product].title || product.charAt(0).toUpperCase() + product.slice(1);
                }

                if (iconTitle && iconData[product].title) {
                    iconTitle.textContent = iconData[product].title;
                }
            });
        } catch (error) {
            console.error('Error parsing data-icons:', error);
        }
    }

    render() {
        this.shadowRoot.innerHTML = `
      <style>
        .backdrop {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          z-index: 999;
        }
        :host {
          display: block;
          position: fixed;
          background-color: white;
          border-radius: 8px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
          z-index: 1000;
          max-width: 90vw;
          width: 800px;
          max-height: 90vh;
          overflow-y: auto;
        }
        
        .popup-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 0;
        }
        
        .popup-title {
          font-size: 28px;
            font-family: Plus Jakarta Sans, sans-serif !important;
            font-weight: 400;
            color: #000;
            letter-spacing: 0;
            line-height: 1.3;
            max-width: 600px;
            margin-top: 0;
        }
        
        .close-button {
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
        }
        
        .meter-feet-toggle {
          text-align: left;
          margin-bottom: 0;
          position: relative;
          top: 55px;
        }
        
        .toggle-button {
          background-color: #f1f1f1;
          border: none;
          padding: 5px 15px;
          border-radius: 15px;
          margin-right: 5px;
          cursor: pointer;
          font-weight: bold;
        }
        
        .toggle-active {
          background-color: #333;
          color: white;
        }
        
        table {
          border-collapse: collapse;
          width: 100%;
        }
        
        th, td {
          padding: 10px 15px;
          text-align: center;
          border-bottom: 1px solid #ddd;
        }
        
        .category {
          font-weight: bold;
          text-align: left;
          color: #000;
        }
        
        .standard-title {
            color: #000;
        }
        
        .subcategory {
          text-align: left;
          color: #666;
          font-size: 0.9em;
        }
        
        .header-row {
          border-bottom: 2px solid #ddd;
          color: #000;
        }
        
        .popup-title {
          color: #000;
        }
        
        .check-mark::before {
        }
        
        .orange-text {
          color: #FF6600;
        }
        
        .product-icon {
          height: 40px;
          margin-bottom: 0;
        }
        .popup-container {
          padding: 20px;
          display: block;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: white;
        width: 100%;
        max-height: 90vh;
        max-width: 90vw;
        border-radius: 6px;
        z-index: 1000;
        }
        
        @media only screen and (max-width: 768px) {
         .popup-container {
                display: block;
                overflow: scroll;
                max-height: 80vh;
                max-width: 87vw;
         }
         td {
            padding: 12px 7px;
         }
         .meter-feet-toggle {
            display: flex;
            flex-direction: column;
            max-width: 90px;
            top: 75px;
            margin-top: -35px;
         }
         .subcategory, .category, td {
         font-size: 12px;
         }
        }
      </style>
      <div class="backdrop"></div>
      <div class="popup-container">
        <div class="popup-header">
          <div class="popup-title">Detail comparison</div>
          <button class="close-button">
            <svg xmlns="http://www.w3.org/2000/svg" width="37" height="37" viewBox="0 0 37 37" fill="none">
                <circle cx="18.75" cy="18.75" r="15" stroke="#1C274C" stroke-width="2.25"></circle>
                <path d="M22.5 15L15 22.5M15 15L22.4999 22.5" stroke="#1C274C" stroke-width="2.25" stroke-linecap="round"></path>
            </svg>
          </button>
        </div>
        
        <div class="meter-feet-toggle">
          <button class="toggle-button toggle-active" data-unit="meter">Meter</button>
          <button class="toggle-button" data-unit="feet">Feet</button>
        </div>
        
        <table>
          <tr class="header-row">
            <th></th>
             <th class="mini-icon-container">
              <img src="/api/placeholder/40/40" alt="Mini" class="product-icon mini-icon">
              <div class="mini-title">Mini</div>
            </th>
            <th class="standard-icon-container">
              <img src="/api/placeholder/40/40" alt="Standard" class="product-icon standard-icon">
              <div class="standard-title">Standard</div>
            </th>
            <th class="large-icon-container">
              <img src="/api/placeholder/40/40" alt="Large" class="product-icon large-icon">
              <div class="large-title">Large</div>
            </th>
          </tr>
          
          <tr>
            <td class="category">Size</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td class="subcategory">Diameter</td>
            <td class="size-diameter-mini"></td>
            <td class="size-diameter-standard"></td>
            <td class="size-diameter-large"></td>
          </tr>
          <tr>
            <td class="subcategory">Height</td>
            <td class="size-high-mini"></td>
            <td class="size-high-standard"></td>            
            <td class="size-high-large"></td>
          </tr>
          
          <tr>
            <td class="category">Panel Thickness</td>
            <td class="panel-thickness-percentage-mini"></td>
            <td class="panel-thickness-percentage-standard"></td>            
            <td class="panel-thickness-percentage-large"></td>
          </tr>
          
          <tr>
            <td class="category">Easy Setup</td>
            <td class="easy-setup-mini"></td>
            <td class="easy-setup-standard"></td>            
            <td class="easy-setup-large"></td>
          </tr>
          
          <tr>
            <td class="category">UV Protected Panels</td>
            <td class="uv-protected-mini"></td>
            <td class="uv-protected-standard"></td>            
            <td class="uv-protected-large"></td>
          </tr>
          
          <tr>
            <td class="category">All Weather Durability</td>
            <td class="all-weather-mini"></td>
            <td class="all-weather-standard"></td>            
            <td class="all-weather-large"></td>
          </tr>
          
          <tr>
              <td class="category">Door Width</td>
              <td class="door-width-width-mini"></td>
              <td class="door-width-width-standard"></td>              
              <td class="door-width-width-large"></td>
          </tr>
          
<!--          <tr>-->
<!--            <td class="subcategory">Limited Space</td>-->
<!--            <td class="limited-space-standard"></td>-->
<!--            <td class="limited-space-mini"></td>-->
<!--            <td class="limited-space-large"></td>-->
<!--          </tr>-->
<!--          <tr>-->
<!--            <td class="subcategory">Garden</td>-->
<!--            <td class="garden-standard"></td>-->
<!--            <td class="garden-mini"></td>-->
<!--            <td class="garden-large"></td>-->
<!--          </tr>-->
<!--          <tr>-->
<!--            <td class="subcategory">Hosting</td>-->
<!--            <td class="hosting-standard"></td>-->
<!--            <td class="hosting-mini"></td>-->
<!--            <td class="hosting-large"></td>-->
<!--          </tr>-->
<!--          <tr>-->
<!--            <td class="subcategory">Art-Built</td>-->
<!--            <td class="art-built-standard"></td>-->
<!--            <td class="art-built-mini"></td>-->
<!--            <td class="art-built-large"></td>-->
<!--          </tr>-->
<!--          <tr>-->
<!--            <td class="subcategory">Gym</td>-->
<!--            <td class="gym-standard"></td>-->
<!--            <td class="gym-mini"></td>-->
<!--            <td class="gym-large"></td>-->
<!--          </tr>-->
        </table>
      </div>
    `;

        this.updateValues();
        this.updateIcons();
    }
}

// Register the custom element
customElements.define('detail-comparison-popup', DetailComparisonPopup);